import React from 'react';
import { Modal, Container, Footer, Content } from './styles';

const ModalComunicado2 = ({
    onClose = () => { },
    onConfirm = () => { },
    handleModalStorage = () => { },
    children,
    title,
    buttonText,
    MessageInline,
    exclusaoParam,
    width,
    height,
    footerRender = null,
}) => {
    return (
        <Modal>
            <Container style={{ width, height }}>
                <button onClick={onClose}>X</button>

                <h1>{title}</h1>

                {/* ⚠️ NÃO envolver children em <p> */}
                <Content>
                    {children}
                </Content>

                <Footer>
                    {footerRender ? (
                        footerRender
                    ) : (
                        <div>
                            <button onClick={onConfirm} id={'subvencoesMsgBtn'} >{buttonText}</button>

                            {/* se você NÃO quer exibir a mensagem "não exibir..." basta passar MessageInline vazio/null */}
                            {MessageInline ? (
                                <p onClick={handleModalStorage}>{MessageInline}</p>
                            ) : null}
                        </div>
                    )}
                </Footer>
            </Container>
        </Modal>
    );
};

export default ModalComunicado2;
